<template>
  <a
    class="first-nav-item"
    :class="{
      active,
      'sk-relative':item.flagText
    }"
    :href="item.href"
    :aria-label="item.name"
    @click="handleClick(item)"
  >
    <template v-if="item.image">
      <img
        class="first-nav-img"
        :src="item.image"
        :alt="item.name"
      >
    </template>
    <template v-else>
      {{ item.text }}
    </template>
    <template v-if="item.flagText">
      <Tag v-if="item.flagText !=='Superkick FreeBet Alarm'">
        {{ item.flagText }}
      </Tag>
      <img
        v-if="$route.meta.showNewTag && item.flagText ==='Superkick FreeBet Alarm'"
        class="first-nav-item-sk"
        src="./images/tag-sk.png"
      >
    </template>

  </a>
</template>

<script>
import Tag from 'wap/components/Tag.vue'

export default {
  name: 'FirstNavItem',
  components: {
    Tag
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    loadedAllImg: {
      type: Boolean,
      default: false
    },
    order: {
      type: Number,
      default: 1
    }
  },
  mounted () {
    if (this.active) {
      this.scrollIntoView()
      const unwatch = this.$watch('loadedAllImg', () => {
        this.scrollIntoView()
        unwatch()
      })
    }

    const img = this.$el.querySelector('img')
    if (img) {
      img.onload = () => {
        img.style.width = img.width + 'px'
        this.$emit('on-load-img')
      }
      img.onerror = () => {
        // default
        img.style.width = '50px'
        this.$emit('on-load-img')
      }
    }
  },
  methods: {
    handleClick (item) {
      window.mstrace(`Home_PrimaryTab${this.order}`, '', { click_text: item.text })
    },
    scrollIntoView () {
      const rect = this.$el.getBoundingClientRect()
      const { left, width } = rect
      if (left + width > window.innerWidth) {
        this.$parent.$el.scrollLeft = window.innerWidth - width - 20
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.first-nav-item {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.01px;
  line-height: 50px;
  text-transform: capitalize;

  &.sk-relative {
    position: relative;
  }

  &:active {
    border-radius: 4px;
    background: fade(#000, 10%);
  }

  .first-nav-img {
    max-height: 20px;
    vertical-align: sub;
  }

  .tag {
    top: -10px;
    right: -4px;
    height: 14px;
    padding: 0 4px;
    border-radius: 7px 7px 7px 0;
    font-style: initial;
    font-weight: 300;
    line-height: 14px;
    text-transform: capitalize;
  }

  &.active {
    color: #ffca27;
    font-size: 18px;
  }

  &-sk {
    position: absolute;
    top: -13px;
    right: 10px;
    width: 75px;
    font-size: 12px;
    transform: translateX(100%);
  }
}

[data-mode='light'] .first-nav-item {
  color: #000;

  &.active {
    color: #000;
  }
}
</style>
